<template>
  <!-- 右侧路由跳转视图 -->
  <router-view></router-view>
</template>

<script>
export default {
  name: 'appMain'
}
</script>
